export default class Product_Zaiko
{
    constructor (data = null)
    {
        if (data !== null)
        {
            // data will be an excel row from the Zaiko sheet
            this.SerialNumber = this.GetCellString(data.getCell(1));
            this.Factory = this.GetCellString(data.getCell(2));

            // The commented code is only required when not
            // passing the value directly into our object's
            // variable (and I don't know why yet)
            
            const v = data.getCell(3).value;
            // console.log('date value type ', typeof v);
            // console.log('date value', v);
            if ( typeof v !== typeof Date)
            {
                const date0 = new Date(0);
                const utcOffset = date0.getTimezoneOffset();
                // console.log('product import date', data.getCell(3).value);
                this.ImportDate = new Date(0, 0, parseInt(data.getCell(3).value) - 1, 0, -utcOffset, 0);
            }

            // 2025/01/15
            // I haven't figured out why, but sometimes the previous code
            // works, sometimes it does not, then the following is working
            if (!(this.ImportDate instanceof Date) || isNaN(this.ImportDate))
            {
                this.ImportDate = data.getCell(3).value;
            }

            // productCode in DB
            this.StyleNumber = this.GetCellString(data.getCell(5));
            this.ProductName = this.GetCellString(data.getCell(6));
            this.JAN = this.GetCellString(data.getCell(7));
            this.ProductionCost = this.GetCellInteger(data.getCell(8));
            this.RetailPrice = this.GetCellInteger(data.getCell(9));
            this.WholesalerPrice = this.GetCellInteger(data.getCell(10));
            // ZaikoData []
            this.SalesData = [];
        }
    }

    GetCellString(cell)
    {
        if (cell.value === null || cell.value === undefined)
        {
            return null;
        }

        if (typeof cell.value !== typeof "string")
        {
            if (Object.hasOwn(cell.value, 'richText') === true)
            {
                const richTextArray = cell.value.richText;
                return richTextArray.map(part => part.text).join('');
            }
        }

        return cell.value.toString().trim();
    }

    GetCellInteger(cell)
    {
        if (cell.value === null || cell.value === undefined)
        {
            return null;
        }

        return Math.round(cell.formula ? cell.result : parseFloat(cell.value));
    }

    GetCellFloat(cell)
    {
        if (cell.value === null || cell.value === undefined)
        {
            return null;
        }
            
        return cell.formula ? cell.result : parseFloat(cell.value);
    }
}